import { DateRange } from '../../types/reducers/user'
import type { EntityId } from '../../types/constants'

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER'
export const REQUEST_USER = 'REQUEST_USER'
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const SET_HIDDEN_COLUMNS = 'SET_HIDDEN_COLUMNS'
export const SET_SCREENSHOT_MODE = 'SET_SCREENSHOT_MODE'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
export const SET_NAV_OPEN = 'SET_NAV_OPEN'
export const SET_URL_SEARCH_PARAMS = 'SET_URL_SEARCH_PARAMS'

export interface SetCurrentUserAction {
    type: typeof SET_CURRENT_USER
    user: Models.User
    receivedAt: number
}

export interface ClearCurrentUserAction {
    type: typeof CLEAR_CURRENT_USER
    receivedAt: number
}

export interface RequestUserAction {
    type: typeof REQUEST_USER
    receivedAt: number
}

export interface SetCurrentProfileAction {
    type: typeof SET_CURRENT_PROFILE
    profile: EntityId
    receivedAt: number
}

export interface SetHiddenColumnsAction {
    type: typeof SET_HIDDEN_COLUMNS
    name: string
    columns: string[]
    receivedAt: number
}

export interface SetScreenshotModeAction {
    type: typeof SET_SCREENSHOT_MODE
    receivedAt: number
}

export interface SetDateRangeAction {
    type: typeof SET_DATE_RANGE
    dateRange: DateRange
    receivedAt: number
}

export interface SetNavOpenAction {
    type: typeof SET_NAV_OPEN
    open: boolean
    receivedAt: number
}

export interface SetURLSearchParamsAction {
    type: typeof SET_URL_SEARCH_PARAMS
    searchParams: string
    receivedAt: number
}

export type UserAction =
    | SetCurrentUserAction
    | ClearCurrentUserAction
    | RequestUserAction
    | SetCurrentProfileAction
    | SetHiddenColumnsAction
    | SetScreenshotModeAction
    | SetDateRangeAction
    | SetNavOpenAction
    | SetURLSearchParamsAction
